export default "__VITE_ASSET__CEJkxD3f__"